export type WinTier = 'bronze' | 'silver' | 'gold' | 'diamond';

export function getWinTier(amount: number): WinTier {
  if (amount >= 100) return 'diamond';
  if (amount >= 20) return 'gold';
  if (amount >= 5) return 'silver';
  return 'bronze';
}
